import React from 'react';
import { useStore } from "../../../../../contexts";
import { selectors } from "../../../../../store/state-selectors";
import { useConnectBankAccount } from "../../../../../hooks/useConnectBankAccount";
import { isBankAccountConnected } from "../../../../../store/store.model";
import { ConnectBankAccountIcon } from "../../BusinessOnboardingWidget.icons";
import { StepLayout } from "../../BusinessOnboardingWidget.utils";
import styles from "./ConnectBankAccount.module.scss";
export default function ConnectBankAccount(props) {
  const {
    isComplete
  } = props;
  const {
    Description,
    ConnectButton,
    BankAccountDetails
  } = useConnectBankAccount();
  const payoutBankAccount = useStore(selectors.user.payoutBankAccount);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StepLayout, {
    id: "connectBankAccount",
    title: isComplete ? "You've successfully connected your bank account" : 'Link your bank account for payouts',
    subtitle: isComplete ? isBankAccountConnected(payoutBankAccount) && /*#__PURE__*/React.createElement(BankAccountDetails, {
      payoutBankAccount: payoutBankAccount
    }) : /*#__PURE__*/React.createElement(Description, {
      linkTestid: "onboarding-widget-connect-account-read-more"
    }),
    actions: /*#__PURE__*/React.createElement(ConnectButton, {
      className: styles.actionsWrapper,
      testid: "onboarding-widget-connect-account-btn",
      enterManuallyTestid: "onboarding-widget-routing-number"
    }),
    icon: /*#__PURE__*/React.createElement(ConnectBankAccountIcon, null)
  }));
}